import { ServiceClient } from 'src/utils'
import { PessoaBean } from './pf.types'

const serviceClient = ServiceClient.singleton()

export class PFService {
    static #INSTANCE = new PFService()
    static readonly singleton = () => PFService.#INSTANCE

    async fetchPersonInfo(cpf: string) {
        return serviceClient.authGet<PessoaBean>(`/api/pf/${cpf}`)
    }
}

export default PFService.singleton()
